<p>pricelists-detail works!</p>
